var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLifepointsNavHome = function SvgLifepointsNavHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 5.981 5.622"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.26458,
    d: "M1.221 2.448v2.777c0 .147.119.265.265.265h3.01a.265.265 0 0 0 .264-.265V2.448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M1.221 2.448v2.777c0 .147.119.265.265.265h3.01a.265.265 0 0 0 .264-.265V2.448"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M1.221 2.448v2.777c0 .147.119.265.265.265h3.01a.265.265 0 0 0 .264-.265V2.448"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M1.221 2.448v2.777c0 .147.119.265.265.265h3.01a.265.265 0 0 0 .264-.265V2.448"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M1.221 2.448v2.777c0 .147.119.265.265.265h3.01a.265.265 0 0 0 .264-.265V2.448"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M1.221 2.448v2.777c0 .147.119.265.265.265h3.01a.265.265 0 0 0 .264-.265V2.448"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    style: {
      fill: "none"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.26458,
    d: "M5.849 2.068A3.13 3.13 0 0 0 4.709.661a3.06 3.06 0 0 0-3.437 0 3.13 3.13 0 0 0-1.14 1.407"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M5.849 2.068A3.13 3.13 0 0 0 4.709.661a3.06 3.06 0 0 0-3.437 0 3.13 3.13 0 0 0-1.14 1.407"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M5.849 2.068A3.13 3.13 0 0 0 4.709.661a3.06 3.06 0 0 0-3.437 0 3.13 3.13 0 0 0-1.14 1.407"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M5.849 2.068A3.13 3.13 0 0 0 4.709.661a3.06 3.06 0 0 0-3.437 0 3.13 3.13 0 0 0-1.14 1.407"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M5.849 2.068A3.13 3.13 0 0 0 4.709.661a3.06 3.06 0 0 0-3.437 0 3.13 3.13 0 0 0-1.14 1.407"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M5.849 2.068A3.13 3.13 0 0 0 4.709.661a3.06 3.06 0 0 0-3.437 0 3.13 3.13 0 0 0-1.14 1.407"
  })))));
};
export default SvgLifepointsNavHome;